query GetPersonalisedHifoRecommendations(
  $preferences: GivingPreferencesInput!
) {
  personalisedHifoRecommendations(preferences: $preferences) {
    id
    reason
    hifo {
      id
      name
    }
  }
}
